module.exports = __webpack_public_path__ + "static/media/white-tick.8df572ed.svg";